<template>
  <div>
    <div align="center" class="row">
      <div class="flex md3 sm12 xs12">
        <div
          class="text-white bg-secondary"
          style="max-width: 18rem; height: 120px !important"
        >
          <div class="card-header pl-3 pt-4">Report ID</div>
          <div class="card-body">
            <h5
              class="card-title"
              style="font-size: 16px; color: white !important"
            >
              {{ crimeData.crimeReportID }}
            </h5>
          </div>
        </div>
      </div>
      <div class="flex md3 sm12 xs12">
        <div
          class="text-white bg-secondary"
          style="max-width: 18rem; height: 120px !important"
        >
          <div class="card-header pl-3 pt-4">Report Method</div>
          <div class="card-body">
            <h5
              class="card-title"
              style="font-size: 16px; color: white !important"
            >
              {{ crimeData.CRtype }}
            </h5>
          </div>
        </div>
      </div>
      <div class="flex md3 sm12 xs12">
        <div
          class="text-white bg-secondary"
          style="max-width: 18rem; height: 120px !important"
        >
          <div class="card-header pl-3 pt-4">Crime</div>
          <div class="card-body">
            <h5
            v-if="crimeData.crimeType"
              class="card-title text-capitalize"
              style="font-size: 16px; color: white !important"
            >
              {{ crimeData.crimeType.cname }}
            </h5>
          </div>
        </div>
      </div>
      <div v-if="crimeData.CRtype == 'online'" class="flex md3 sm12 xs12">
        <div
          class="text-white bg-secondary"
          style="max-width: 18rem; height: 120px !important"
        >
          <div class="card-header pl-3 pt-4">Online Source</div>
          <div class="card-body">
            <h5
              class="card-title text-capitalize"
              style="font-size: 16px; color: white !important"
            >
              {{ crimeData.source.sname }} <span v-if="crimeData.source.sname=='Others'">({{ crimeData.medium }})</span>
            </h5>
            
          </div>
        </div>
      </div>

      <div v-if="crimeData.knownSpecies == 'yes' && crimeData.includeinSpecies == 'yes'" class="flex md3 sm12 xs12">
        <div
          class="text-white bg-secondary"
          style="max-width: 18rem; height: 120px !important"
        >
          <div class="card-header pl-3 pt-4">Species</div>
          <div class="card-body">
            <h5
              class="card-title text-capitalize"
              style="font-size: 16px; color: white !important"
            >
              {{ crimeData.species.commonName }}
            </h5>
          </div>
        </div>
      </div>
       <div v-if="crimeData.includeinSpecies == 'no'" class="flex md3 sm12 xs12">
        <div
          class="text-white bg-secondary"
          style="max-width: 18rem; height: 120px !important"
        >
          <div class="card-header pl-3 pt-4">Species</div>
          <div class="card-body">
            <h5
              class="card-title text-capitalize"
              style="font-size: 16px; color: white !important"
            >
              {{ crimeData.speciesName }}
            </h5>
          </div>
        </div>
      </div>
      <div class="flex md3 sm12 xs12">
        <div
          class="text-white bg-secondary"
          style="max-width: 18rem; height: 120px !important"
        >
          <div class="card-header pl-3 pt-4">Suspect Available?</div>
          <div class="card-body">
            <h5
              v-if="
                crimeData.contributorEmail ||
                crimeData.contributorName ||
                crimeData.contributorPhone
              "
              class="card-title text-capitalize"
              style="font-size: 16px; color: white !important"
            >
              Yes
            </h5>
            <h5
              v-else
              class="card-title text-capitalize"
              style="font-size: 16px; color: white !important"
            >
              No
            </h5>
          </div>
        </div>
      </div>
      <div
        v-scroll-to="{ element: '#status', duration: 1000 }"
        class="flex md3 sm12 xs12"
      >
        <div
          class="text-white bg-secondary"
          style="max-width: 18rem; height: 120px !important"
        >
          <div class="card-header pl-3 pt-4">Status</div>
          <div class="card-body">
            <h5
              class="card-title text-capitalize"
              style="font-size: 16px; color: white !important"
            >
              {{ crimeData.status }}
            </h5>
          </div>
        </div>
      </div>
      <div
        v-scroll-to="{ element: '#act', duration: 2000 }"
        class="flex md3 sm12 xs12"
      >
        <div
          class="text-white bg-secondary"
          style="max-width: 18rem; height: 120px !important"
        >
          <div class="card-header pl-3 pt-4">Action</div>
          <div class="card-body">
            <h5
            v-if="crimeData.action"
              class="card-title text-capitalize"
              style="font-size: 16px; color: white !important"
            >
              {{ crimeData.action.slice(0, 20) }} ...
            </h5>
          </div>
        </div>
      </div>
            <div
        v-scroll-to="{ element: '#priority', duration: 2000 }"
        class="flex md3 sm12 xs12"
      >
        <div
          class="text-white bg-secondary"
          style="max-width: 18rem; height: 120px !important"
        >
          <div class="card-header pl-3 pt-4">Priority</div>
          <div class="card-body">
            <h5
              class="card-title text-capitalize"
              style="font-size: 16px; color: white !important"
            >
              {{ priority}}
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["crimeData","priority"],
};
</script>